import {
  ETH_CURRENCY_EXCHANGE_RATES_FETCHED,
  ETH_CURRENCY_EXCHANGE_RATES_FETCH_FAILED,
  ETH_CURRENCY_EXCHANGE_RATES_LOCAL_LOADED,
  CAT_ETH_EXCHANGE_RATE_FETCHED,
  CAT_ETH_EXCHANGE_RATE_FETCH_FAILED,
  CAT_ETH_EXCHANGE_RATE_LOCAL_LOADED,
  CURRENCY_CODE_CHANGE,
  CURRENCY_CODE_LOCAL_LOADED,
} from '../actionTypes';

export const ethCurrencyExchangeRatesFetched = ethExchangeRates => ({
  type: ETH_CURRENCY_EXCHANGE_RATES_FETCHED,
  ethExchangeRates,
});

export const ethCurrencyExchangeRatesFetchFailed = error => ({
  type: ETH_CURRENCY_EXCHANGE_RATES_FETCH_FAILED,
  error,
});

export const ethCurrencyExchangeRatesLocallyLoaded = ethExchangeRates => ({
  type: ETH_CURRENCY_EXCHANGE_RATES_LOCAL_LOADED,
  ethExchangeRates,
});

export const catEthExchangeRateFetched = catEthExchangeRate => ({
  type: CAT_ETH_EXCHANGE_RATE_FETCHED,
  catEthExchangeRate,
});

export const catEthExchangeRateFetchFailed = error => ({
  type: CAT_ETH_EXCHANGE_RATE_FETCH_FAILED,
  error,
});

export const catEthExchangeRateLocallyLoaded = catEthExchangeRate => ({
  type: CAT_ETH_EXCHANGE_RATE_LOCAL_LOADED,
  catEthExchangeRate,
});

export const currencyCodeChange = currencyCode => ({
  type: CURRENCY_CODE_CHANGE,
  currencyCode,
});

export const currencyCodeLoaded = currencyCode => ({
  type: CURRENCY_CODE_LOCAL_LOADED,
  currencyCode,
});



// WEBPACK FOOTER //
// ./src/actions/currencyExchangeRates.js